"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _mobx = require("mobx");

var _noop = _interopRequireDefault(require("lodash/noop"));

var _class, _descriptor, _descriptor2;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

var ModalModel = (_class = /*#__PURE__*/function () {
  function ModalModel(modalKey) {
    var modalTitle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    var modalWillClose = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _noop.default;

    _classCallCheck(this, ModalModel);

    _initializerDefineProperty(this, "isOpen", _descriptor, this);

    _initializerDefineProperty(this, "title", _descriptor2, this);

    this.modalKey = modalKey;
    this.title = modalTitle;
    this.modalWillClose = modalWillClose;
  }

  _createClass(ModalModel, [{
    key: "open",
    value: function open() {
      this.isOpen = true;
    }
  }, {
    key: "close",
    value: function close(dispatcher) {
      this.modalWillClose();
      this.isOpen = false;

      if (dispatcher) {
        dispatcher.emit("HIDE_MODAL", {
          modalKey: this.modalKey
        });
      }
    }
  }]);

  return ModalModel;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "isOpen", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "title", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
})), _class);
var _default = ModalModel;
exports.default = _default;